module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00050.fe497af2.jpg";